import React, { useState, useEffect, useContext } from 'react';
import {
    Label, FieldControl, Alert, Select, SelectOption, 
    Tooltip,
    TooltipButton,
GlyphInfo} from '@americanexpress/dls-react';
import moment from 'moment';
import UserContext from '../ContextComponent/UserContext';

function DateOfBirth() {
    const [dayRequired, setDayRequiredFlag] = useState(false);
    const [monthRequired, setMonthRequiredFlag] = useState(false);
    const [yearRequired, setYearRequiredFlag] = useState(false);
    const [fullDob, setFullDob] = useState({dayOfBirth: '', monthOfBirth:'', yearOfBirth:'',fullDateOfBirth:''}); 
    const [dateError, setDateError] = useState(true);
    const [underAgeError, setUnderAgeError] = useState(false);
    const { formData, setFormData } = useContext(UserContext);
    const {errorData, setErrorData} = useContext(UserContext);

    const year = (new Date()).getFullYear();
    const years = Array.from(new Array(100), (val, index) => year - 18 - index);
    const months = Array.from(new Array(12), (val, index) => index + 1);
    const days = Array.from(new Array(31), (val, index) => index + 1);

    const onDayChange = (event) => {
        if (event.target.value === '')
            setDayRequiredFlag(true);
        else {
            setDayRequiredFlag(false);
            setFullDob({...fullDob, fullDateOfBirth: `${fullDob.monthOfBirth}-${event.target.value}-${fullDob.yearOfBirth}`});
        }
    };
    const onMonthChange = (event) => {
        if (event.target.value === '')
            setMonthRequiredFlag(true);
        else {
            setMonthRequiredFlag(false);
            setFullDob({...fullDob, fullDateOfBirth: `${event.target.value}-${fullDob.dayOfBirth}-${fullDob.yearOfBirth}`});
        }
    };
    const onYearChange = (event) => {
        if (event.target.value === '')
            setYearRequiredFlag(true);
        else {
            setYearRequiredFlag(false);
            setFullDob({...fullDob, fullDateOfBirth: `${fullDob.monthOfBirth}-${fullDob.dayOfBirth}-${event.target.value}`});
        }
    };
    const getDayOfBirth = (event) => {
        if (event.target.value !== '') {
            setFullDob({...fullDob, dayOfBirth: event.target.value});
            setErrorData({ ...errorData, dateOfBirthRequired: false }); 
        }
        else {
            setErrorData({ ...errorData, dateOfBirthRequired: true });
        }
    };
    const getMonthOfBirth = (event) => {
        if (event.target.value !== '') {
            setFullDob({...fullDob, monthOfBirth: event.target.value}); 
            setErrorData({ ...errorData, dateOfBirthRequired: false }); 
        }
        else{
            setErrorData({ ...errorData, dateOfBirthRequired: true });
        }
    };
    const getYearOfBirth = (event) => {
        if (event.target.value !== '') {
            setFullDob({...fullDob, yearOfBirth: event.target.value}); 
            setErrorData({ ...errorData, dateOfBirthRequired: false }); 
        }
        else{
            setErrorData({ ...errorData, dateOfBirthRequired: true });
        }
    };
    
    useEffect(() => {
        const validateDate = (event) => {
            if(fullDob.dayOfBirth !== '' && fullDob.monthOfBirth !== '' && fullDob.yearOfBirth !== '') {
                setDateError(moment(fullDob.fullDateOfBirth, "MM-DD-YYYY").isValid());
                const dobDate = fullDob.fullDateOfBirth;
                const today = new Date();
                const formattedDobDate = moment(dobDate, 'MM.DD.YYYY');
                const formattedTodayDate = moment(today, 'MM.DD.YYYY');
                const timeDiff = Math.abs(formattedTodayDate-formattedDobDate);
                const ageInYears = (timeDiff / (1000*60*60*24*365.25));
                if(ageInYears < 18) {
                    setUnderAgeError(true);
                }
                else {
                    setUnderAgeError(false);
                }
                //Comment by Ashish on Date 29-04-2022 for testing the pick date of birth in firefox
                //setFormData({ ...formData, dateOfBirth: (moment(dobDate).add(1, "days")) })
                setFormData({ ...formData, dateOfBirth: moment.utc(dobDate, 'MM-DD-YYYY HH:mm:ss').local() })
            }
        }
        validateDate()
      }, [fullDob]); 

    return (
        <div>
            <FieldControl>
                <Label id="DateOfBirth-label" htmlFor="DateOfBirth" className="label-1">
                    Date Of Birth &nbsp;
                </Label>
                <Tooltip
                    id="tooltip-info-right"
                    triggerElement={(
                        <TooltipButton info={true} icon={<GlyphInfo />} />
                    )}
                    placement="top"
                    info={true}
                >
                    You are required to be 18 years and above to apply.
                </Tooltip>
                <div className="row flex-align-items-end">
                    <div className="flex flex-column col-xs-4">
                        <Select id="dateOfBirth-day"
                            aria-labelledby="dobDay-alert"
                            onChange={onDayChange}
                            onBlur={getDayOfBirth}
                            required={true}>
                            <SelectOption value="">Day</SelectOption>
                            {
                                days.map((day, index) => {
                                    return <SelectOption key={day} value={day}>{day}</SelectOption>
                                })
                            }
                        </Select>

                    </div>
                    <div className="flex flex-column col-xs-4">
                        <Select id="dateOfBirth-month"
                        aria-labelledby="dobMonth-alert"
                            onChange={onMonthChange}
                            onBlur={getMonthOfBirth}
                            required={true}>
                            <SelectOption value="">Month</SelectOption>
                            {
                                months.map((month, index) => {
                                    return <SelectOption key={month} value={month}>{month}</SelectOption>
                                })
                            }
                        </Select>

                    </div>
                    <div className="flex flex-column col-xs-4">
                        <Select id="dateOfBirth-year"
                            onChange={onYearChange}
                            onBlur={getYearOfBirth}
                            aria-labelledby="dobYear-alert"
                            required={true}>
                            <SelectOption value="">Year</SelectOption>
                            {
                                years.map((year, index) => {
                                    return <SelectOption key={year} value={year}>{year}</SelectOption>
                                })
                            }
                        </Select>

                    </div>
                </div>
            </FieldControl>
            <Alert id="dobDay-alert" show={dayRequired}>Please ensure Date of birth is a valid date.</Alert>
            <Alert id="dateError-alert" show={!dateError}>Please ensure Date of birth is a valid date.</Alert>
            <Alert id="dobMonth-alert" show={monthRequired}>Please select month.</Alert>
            <Alert id="dobYear-alert" show={yearRequired}>Please select year.</Alert>
            <Alert id="underAge-alert" show={underAgeError}>Please ensure Date of birth is a valid date.</Alert>
            <Alert id="dobNull-alert" show={errorData.dateOfBirthRequired}>Please enter your Date of birth.</Alert>
        </div>
    );
}
export default DateOfBirth;